import UploadIcon from "@mui/icons-material/Upload";
import { Files, Folder } from "lucide-react";
import ButtonMenu from "../Buttons/ButtonMenu";
import {
  BUTTON_UPLOAD,
  BUTTON_UPLOAD_FILES,
  BUTTON_UPLOAD_FOLDER,
} from "../../i18n/keysTranslations";

const GalleryUploadMenu = ({
  isUploading = false,
  disabled = false,
  onUploadFiles = () => {},
  onUploadFolder = () => {},
  sx = {},
}) => {
  return (
    <ButtonMenu
      mode="button"
      colorButton="secondary"
      textButton={BUTTON_UPLOAD}
      loading={isUploading}
      disabled={disabled || isUploading}
      iconButton={
        isUploading ? null : <UploadIcon sx={{ fontSize: 20, mr: 1 }} />
      }
      options={[
        {
          label: BUTTON_UPLOAD_FILES,
          icon: <Files size={18} style={{ marginRight: 8 }} />,
          onClick: onUploadFiles,
          disabled: isUploading,
        },
        {
          label: BUTTON_UPLOAD_FOLDER,
          icon: <Folder size={18} style={{ marginRight: 8 }} />,
          onClick: onUploadFolder,
          disabled: isUploading,
        },
      ]}
      sx={sx}
    />
  );
};

export default GalleryUploadMenu;
